import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const OrganizedTourQuoteCommissionContext = createContext(null);

/**
 * הצעות מחיר למאורגנים בלבד: override מה-SSOT של המערכת (מציג מחיר ללקוח במסך).
 * שמירה לשרת מתבצעת רק בפעולות snapshot: קישור ציבורי, PDF או העתקת מלל שיווקי.
 */
export function OrganizedTourQuoteCommissionProvider({ children }) {
  const [override, setOverrideState] = useState(null);

  const setOrganizedTourQuoteOverride = useCallback((next) => {
    setOverrideState(next);
  }, []);

  const clearOverride = useCallback(() => setOverrideState(null), []);

  const value = useMemo(
    () => ({
      override,
      setOrganizedTourQuoteOverride,
      clearOverride,
    }),
    [override, setOrganizedTourQuoteOverride, clearOverride]
  );

  return (
    <OrganizedTourQuoteCommissionContext.Provider value={value}>
      {children}
    </OrganizedTourQuoteCommissionContext.Provider>
  );
}

/** @returns {null|{override: *, setOrganizedTourQuoteOverride: Function, clearOverride: Function}} */
export function useOrganizedTourQuoteCommission() {
  return useContext(OrganizedTourQuoteCommissionContext);
}
